import { Activity } from "@entities/activity";
import { RichText } from "@shared/ui/rich-text";
import Image from "next/image";
import { forwardRef } from "react";

export type ItemProps = {
  activity: Activity;
  onClick?: (name: string) => void;
  showSummary?: boolean;
  className?: string;
};

export const Item = forwardRef<HTMLDivElement, ItemProps>(function Item(
  { activity: { name, summary, image }, onClick, showSummary, className },
  ref
) {
  return (
    <div
      ref={ref}
      className={[
        `flex flex-col justify-center items-center w-full h-full gap-4 p-8 aspect-square xl:aspect-[0.9] 2xl:aspect-[1.2] bg-gray-200 rounded hover:transition-all transform-gpu hover:bg-gray-200 hover:outline outline-gray-200 outline-8 cursor-pointer`,
        className,
      ].join(" ")}
      onClick={() => onClick?.(name)}
    >
      <Image src={image} alt="Image" width={56} height={56} />

      <RichText
        className={"text-lg text-persian-plum-900 text-center lg:[&>br]:hidden"}
        message={name}
      />

      {showSummary && (
        <RichText
          className={"text-black-pearl-950 text-center"}
          message={summary ?? ""}
        />
      )}
    </div>
  );
});
